module.exports = __webpack_public_path__ + "b7bab1f11652d62eb6c60214d7f36a62.svg";